import React from 'react';
import { Status } from './FsStatusLabel.style-elements';

interface FsStatusLabelProps {
  bgColor?: string;
  color?: string;
  isFullWidth?: boolean;
}

const FsStatusLabel: React.FC<FsStatusLabelProps> = ({
  children,
  isFullWidth,
  bgColor,
  color,
}) => {
  return (
    <Status bgColor={bgColor} fontColor={color} isFullWidth={isFullWidth}>
      {children}
    </Status>
  );
};

export default FsStatusLabel;
